import React from 'react';

import './style.css';
import { isMobile } from '../../helpers/utils';
import { isNull } from "lodash";


const imgPaths = {
    'mobile': ["images/SwitchLock.png", "images/SwitchOn.png", "images/SwitchOff.png"],
    'desktop': ["images/toggle-locked.png", "images/toggle-on.png", "images/toggle-off.png"]
}

const Switch = ({ enabled = false, onClick, isVerified, readValue, category = '' }) => {
    const paths = isMobile() ? imgPaths['mobile'] : imgPaths['desktop'];
    console.log("item:", readValue);

    if (!isVerified) {
        return null;
    }
    const displayValue = isNull(readValue) ? `` : (readValue + (enabled ? ' On' : ' Off'));

    return (
        <div className="switche">
            {
                enabled ?
                    // <Button aria-live={enabled ? ` Enabled` : ` Disabled`} aria-label={displayValue + category ` alert ` + toggleStatus} tabIndex={0} onClick={() => onClick()} className={isMobile() ? "enableSwitch-Mobile" : "enableSwitch"} /> :
                    // <Button aria-live={enabled ? ` Enabled` : ` Disabled`}  aria-label={displayValue + category ` alert ` + toggleStatus} tabIndex={0} onClick={() => onClick()} className={isMobile() ? "disableSwitch-Mobile" : "disableSwitch"} />
                    <button
                        aria-label={displayValue}
                        tabIndex={0}
                        className="noBorder"
                        onClick={() => onClick()}>
                        <img
                            alt={`service enabled for` + isNull(readValue) ? `` : readValue}
                            src={paths[1]}
                        />
                    </button> :
                    <button aria-label={displayValue} tabIndex={0} className="noBorder" onClick={() => onClick()}>
                        <img alt={`service disabled for` + isNull(readValue) ? `` : readValue} src={paths[2]} />
                    </button>
            }

        </div>
    )
};

export default Switch;
